import './style.css';

import createReactClass from 'create-react-class';
import _ from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import PublishMixin from '../../../mixins/publish-mixin';
import { colours } from '../../../styles/colours';
import Text from '../../clinical/clinical-text';
import ReadOnly from '../../clinical/read-only';
import ButtonGroup from '../button-group';

export default createReactClass({
  displayName: 'YesNo',
  mixins: [PublishMixin],

  getDefaultProps: function () {
    return { material: false };
  },

  render: function () {
    let src = [
      { text: 'Yes', value: true },
      { text: 'No', value: false }
    ];
    let className = '';
    let { valueOther, onChangeOther, value } = this.props;
    let style = _.extend({}, this.props.style, this.props.errorStyle);

    if (this.props.errored) {
      className = 'error';
    } else if (this.props.warning && !this.props.value) {
      className = 'warning';
    }

    let labelTxt = this.findText(this.get() || this.props.value, src);

    if ((valueOther || '').length > 0) {
      if (
        (this.props['text-if-yes'] && this.get() === 'true') ||
        (this.props['text-if-no'] && this.get() === 'false')
      )
        labelTxt += ' - ' + valueOther;
    }

    if (this.props.material) {
      if (this.props.readOnly) {
        return <ReadOnly label={this.props.label} value={labelTxt} />;
      }

      return (
        <ButtonGroup
          src={src}
          mode="single"
          className={className}
          style={this.props.style}
          label={!this.props.inline ? this.props.label : ''}
          errorStyle={this.props.errorStyle}
          readOnly={this.props.readOnly}
          onChange={this.props.onChange?.bind(this)}
          value={value}
        />
      );
    }

    let label = null;
    if (!this.props.inline && !this.props.hideLabel) {
      label = (
        <span style={{ color: colours.lightBlue, fontSize: 16, display: 'block' }}>
          {this.props.label}
        </span>
      );
    }

    if (this.props.readOnly) {
      return <ReadOnly label={label} value={labelTxt} />;
    }

    let textIfYes = null,
      textIfNo = null;
    if (this.props['text-if-yes'] && this.get() === 'true')
      textIfYes = (
        <div className={'yes-no-details'}>
          <Text
            value={valueOther}
            onChange={onChangeOther}
            label="Details"
            hintText="Please explain the 'Yes' answer."
            inline={this.props.inline}
            required={true}
          />
        </div>
      );

    if (this.props['text-if-no'] && this.get() === 'false')
      textIfNo = (
        <div className={'yes-no-details'}>
          <Text
            value={valueOther}
            onChange={onChangeOther}
            label="Details"
            hintText="Please explain the 'No' answer."
            inline={this.props.inline}
            required={true}
          />
        </div>
      );

    return (
      <span>
        {label}
        <div className={'bz-yes-no ' + className} style={style}>
          <div className={this.props.className}>
            <ButtonGroup
              src={src}
              mode="single"
              style={this.props.style}
              errorStyle={this.props.errorStyle}
              readOnly={this.props.readOnly}
              onChange={this.props.onChange?.bind(this)}
              value={value}
            />
          </div>
          {textIfYes}
          {textIfNo}
        </div>
      </span>
    );
  },

  findText: function (valueKey, array) {
    if (typeof valueKey === 'boolean') {
      valueKey = valueKey.toString();
    }
    for (let i = 0; i < array.length; i++) {
      if (array[i].value.toString() === valueKey) {
        return array[i].text;
      }
    }
    return null;
  }
});
